'use client';

import { RectangleSkeleton } from '@fe-common-ui/Skeleton';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const PopTopicSearch = dynamic(() => import('@fe-news/components/molecules/PopTopicSearch/index'), {
  loading: () => <RectangleSkeleton width={110} height={28} borderRadius={3} />,
  ssr: false
});

type DynamicLoadSearchBarProps = {
  isDetailPage?: boolean;
};

const DynamicLoadSearchBar: React.FC<DynamicLoadSearchBarProps> = ({ isDetailPage = false }) => {
  return (
    <Suspense>
      <PopTopicSearch isDetailPage={isDetailPage} />
    </Suspense>
  );
};

export default DynamicLoadSearchBar;
